import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import UploadForm from "components/shared-components/UploadForm";
import {
  ISSUE_INVOICE_BUYER_FIELD,
  ISSUE_INVOICE_COMMON_FIELD,
  ISSUE_INVOICE_HHDV_FIELD,
  ISSUE_INVOICE_SELLER_FIELD,
  MODE_INVOICE_ACTION,
  TYPE_ADJUST_INVOICE,
  TYPE_INVOICE_ANOTHER,
} from "constants/DeliveryBillConstant";
import { FIELD_DISABLE_CONFIG } from "constants/IssueInvoiceConstant";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import {
  EXTRA_BUTTON,
  generateDateField,
  generateInputFieldArray,
  generateSelectFieldArray,
  loopGenerateField,
} from "helpers/form_helper";
import { formatTimestampToDate } from "pages/DataFormatInvoice/utils";
import { FIELD_CUSTOMER } from "pages/GeneralInfo/Customer/utils";
import SearchCustomerModal from "pages/IssueInvoice/modal/SearchCustomerModal";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  adjustIssueInvoice,
  createIssueInvoice,
  createListProductInvoice,
  downloadXmlIssueInvoice,
  editIssueInvoice,
  getAllProductInvoice,
  getDetailIssueInvoice,
  getEnterpriseByTaxCode,
  loadConfigInvoiceField,
  replaceIssueInvoice,
  resetCreateIssueInvoice,
  resetEditIssueInvoice,
  resetGetDetailIssueInvoice,
  resetUploadAttackFileInvoice,
  uploadAttackFileInvoice,
} from "store/actions";
import { getAllCustomerInvoice } from "store/general-info/customer/actions";
import * as yup from "yup";
import {
  changeYearOfSerial,
  convertDate,
  docso,
  fixConvertNumberToText,
  getDateMidnight,
  getIconFile,
  initOptionDateLocale,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "../../IssueInvoice/utils";

const DetailBill = props => {
  const {
    isOpenModal,
    dataDetail,
    dataConfirmAction,
    toggleModal,
    mode,
    pageView,
    typeInvoiceAnother,
    khhdonDefault,
    showPdfById,
    invoiceSymbolList,
    isShowAttacksFile,
    setKhhdonDefault,
    setPageView,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["deliveryBill"]);
  const { addToast } = useToasts();
  const [disableForm, setDisableForm] = useState(true);
  const [isEditableAdjustReplace, setIsEditableAdjustReplace] = useState(true);

  // Search modal
  const [modalSearch, setModalSearch] = useState(false);
  const toggleSearchModal = () => setModalSearch(!modalSearch);

  const [isTypeAdjustIncDesc, setIsTypeAdjustIncDesc] = useState(false);
  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingCreate,
    errorCreate,
    create: issueInvoiceCreate,

    loadingEdit,
    errorEdit,
    edit: issueInvoiceEdit,

    configField,

    uploadFile,
    loadingUploadFile,
    currentTime,
  } = issueInvoice;

  const {
    loading: loadingDetail,
    data: detailIssueInvoice,
    error,
  } = issueInvoice.detailIssueInvoice;
  const {
    loading: loadDingEnterpriseByTaxCode,
    data: enterpriseByTaxCode,
    error: errorEnterprise,
  } = issueInvoice.enterpriseByTaxCode;

  const {
    loading: loadingConfigField,
    // businessUnitInfo,
    listCurrency,
    listVat,
  } = configField;

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuReleaseInfo } = Dashboard;

  const [typeAnother, setTypeAnother] = useState(null);
  const modal = useRef(null);
  const setDefaultConfigField = () => {
    const defaultBusinessUnitInfoField = {
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_TEN.field]: "ten",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_MST.field]: "mst",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_DCHI.field]: "dchi",
    };
    if (finalBuReleaseInfo) {
      for (const key in defaultBusinessUnitInfoField) {
        const defaultValue =
          finalBuReleaseInfo[defaultBusinessUnitInfoField[key]];
        if (defaultValue) {
          setValue(key, defaultValue);
        } else {
          setValue(key, "");
        }
      }
    }
    // Set config hình thức thanh toán

    // Set config đơn vị tiền tệ
    setDVTTE(listCurrency);
    setValue(COMMON_FIELD.TTCHUNG_DVTTE.field, listCurrency[0]);

    // Set config thuế suất
    setTSUAT(listVat);

    setOPTION_GROUP({
      ...OPTION_GROUP,
      [COMMON_FIELD.TTCHUNG_DVTTE.field]: listCurrency,
      [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]:
        productInvoice.listAllProduct.map(item => {
          return {
            ...item,
            value: item.code,
            label: item.code,
          };
        }),
      [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: productInvoice.listAllProduct,
      //   [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: listVat,
    });

    if (!configField.loadingConfigField) {
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
        }
      });
    }
  };

  const productInvoice = useSelector(state => state.productInvoice);
  // Action Dispatch
  useEffect(() => {
    dispatch(getAllProductInvoice());
  }, []);

  const COMMON_FIELD = ISSUE_INVOICE_COMMON_FIELD;
  const COMMON_FIELD_ARRAY = [];
  for (const key in COMMON_FIELD) {
    COMMON_FIELD_ARRAY.push(key);
  }

  const SELLER_FIELD = ISSUE_INVOICE_SELLER_FIELD;
  const SELLER_FIELD_ARRAY = [];
  for (const key in SELLER_FIELD) {
    SELLER_FIELD_ARRAY.push(key);
  }

  const BUYER_FIELD = ISSUE_INVOICE_BUYER_FIELD;
  const BUYER_FIELD_ARRAY = [];
  for (const key in BUYER_FIELD) {
    BUYER_FIELD_ARRAY.push(key);
  }

  const HHDV_FIELD = ISSUE_INVOICE_HHDV_FIELD;
  const HHDV_FIELD_ARRAY = [];
  for (const key in HHDV_FIELD) {
    HHDV_FIELD_ARRAY.push(key);
  }
  const TCHAT_VALUES =
    ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TCHAT.selectValues;

  const OPTION_TTCHUNG_KHMSHDON = [
    {
      value: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.DELIVERY_BILL,
      label: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.DELIVERY_BILL + "",
    },
  ];

  const OPTION_HHDV_TCHAT = [
    {
      value: TCHAT_VALUES.GOODS,
      label: "Hàng hóa, dịch vụ",
    },
    {
      value: TCHAT_VALUES.PROMOTION,
      label: "Khuyến mãi",
    },
    {
      value: TCHAT_VALUES.DISCOUNT,
      label: "Chiết khấu thương mại",
    },
    {
      value: TCHAT_VALUES.EXPLAIN,
      label: "Ghi chú/diễn giải",
    },
  ];

  const [OPTION_TTCHUNG_DVTTE, setDVTTE] = useState([]);
  const [OPTION_HHDV_TSUAT, setTSUAT] = useState([]);

  const [OPTION_GROUP, setOPTION_GROUP] = useState({
    [COMMON_FIELD.TTCHUNG_KHMSHDON.field]: OPTION_TTCHUNG_KHMSHDON,
    [COMMON_FIELD.TTCHUNG_DVTTE.field]: OPTION_TTCHUNG_DVTTE,
    [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT,
    // [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: OPTION_HHDV_TSUAT,
  });

  const objSchema = {};
  const initDefaultValues = {};
  const TOTAL_FIELD = {
    ...COMMON_FIELD,
    ...SELLER_FIELD,
    ...BUYER_FIELD,
    ...HHDV_FIELD,
  };

  const TOTAL_FIELD_ARRAY = [
    ...COMMON_FIELD_ARRAY,
    ...SELLER_FIELD_ARRAY,
    ...BUYER_FIELD_ARRAY,
    ...HHDV_FIELD_ARRAY,
  ];

  TOTAL_FIELD_ARRAY.map(item => {
    const itemField = TOTAL_FIELD[item];
    switch (itemField.type) {
      case "text":
        initDefaultValues[itemField.field] = "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.char_max", { max: itemField.max })
          );
        }
        if (itemField.isEmail) {
          objSchema[itemField.field] = objSchema[itemField.field].email(
            t("form.validate.invalid", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.isTaxCode) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "len",
            "Vui lòng nhập 10 hoặc 14 ký tự",
            val => val.length === 0 || val.length === 10 || val.length === 14
          );
        }
        if (itemField.isKHHD) {
          //   objSchema[itemField.field] = objSchema[itemField.field].matches(
          //     /^[A]*$/,
          //     "Vui lòng chỉ nhập các ký tự (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)"
          //   );
          // objSchema[itemField.field] = objSchema[itemField.field].test(
          //   "len",
          //   "Vui lòng nhập 2 ký tự cuối (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)",
          //   val => {
          //     return val.length === 6;
          //   }
          // );
          initDefaultValues[itemField.field] = undefined;

          objSchema[itemField.field] = objSchema[itemField.field];
          objSchema[itemField.field] = yup.object();
          if (itemField.required) {
            objSchema[itemField.field] = objSchema[itemField.field].required(
              t("form.validate.select", { title: t(`form.${itemField.field}`) })
            );
          }
        }
        // Nếu có nhập MST người mua thì phải nhập địa chỉ
        if (itemField.field === ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
            {
              is: name => name.length === 10 || name.length === 14,
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(`form.${ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field}`),
                })
              ),
            }
          );
        }
        break;
      case "number":
        initDefaultValues[itemField.field] = "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }

        // objSchema[itemField.field] = objSchema[itemField.field].matches(
        //   /^[0-9]+$/,
        //   t("form.validate.integer")
        // );

        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.integer_max", { max: itemField.max })
          );
        }
        break;
      case "select":
        initDefaultValues[itemField.field] = undefined;
        objSchema[itemField.field] = yup.object();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "date":
        initDefaultValues[itemField.field] = [];

        objSchema[itemField.field] = yup.array();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].min(
            1,
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "field_array":
        objSchema[itemField.field] = yup
          .array()
          .min(1, t("form.validate.least_one_line"));
        const objSchemaFieldArray = {};

        const listField = itemField.list;
        const arrayField = [];
        for (const key in listField) {
          if (key !== "STT") {
            arrayField.push(key);
          }
        }

        arrayField.map(x => {
          const itemFieldArray = listField[x];
          switch (itemFieldArray.type) {
            case "text":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .string()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.required", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              if (itemFieldArray.max) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].max(
                  itemFieldArray.max,
                  t("form.validate.char_max", { max: itemFieldArray.max })
                );
              }
              break;
            case "number":
              objSchemaFieldArray[itemFieldArray.field] = yup.string();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.required", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }

              //   objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
              //     itemFieldArray.field
              //   ].matches(/^[0-9]+$/, t("form.validate.integer"));

              if (itemFieldArray.max) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].max(
                  itemFieldArray.max,
                  t("form.validate.integer_max", { max: itemFieldArray.max })
                );
              }
              break;
            case "select":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .object()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.select", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              break;
            case "date":
              objSchemaFieldArray[itemFieldArray.field] = yup.array();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].min(
                  1,
                  t("form.validate.select", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              break;
            default:
              break;
          }
        });

        objSchema[itemField.field] = objSchema[itemField.field].of(
          yup.object().shape(objSchemaFieldArray)
        );
        break;
      case "object":
        objSchema[itemField.field] = yup.mixed().nullable();
        break;
      default:
        break;
    }
  });

  // ---Set Other Default Value---
  initDefaultValues[COMMON_FIELD.PBAN.field] = "2.0.0";
  initDefaultValues[COMMON_FIELD.TTCHUNG_SHDON.field] = "Chờ cấp số";

  initDefaultValues[COMMON_FIELD.TTCHUNG_NLAP.field] = [
    getDateMidnight(currentTime?.data?.date),
  ];
  initDefaultValues[COMMON_FIELD.TTCHUNG_TGIA.field] = 1;
  initDefaultValues[COMMON_FIELD.TTCHUNG_MSTTCGP.field] = "0302999571";

  const schema = yup.object().shape(objSchema);
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...initDefaultValues,
    },
  });

  const customerInvoice = useSelector(state => state.customerInvoice);
  const { listAllCustomer, loadListAllCustomer } = customerInvoice;

  const [isShowBtnAddCustomer, setIsShowBtnAddCustomer] = useState(false);

  useEffect(() => {
    if (isOpenModal && enterpriseByTaxCode?.taxCode) {
      if (
        listAllCustomer.findIndex(
          item => item.mst === enterpriseByTaxCode?.taxCode
        ) === -1
      ) {
        setIsShowBtnAddCustomer(true);
      } else {
        setIsShowBtnAddCustomer(false);
      }
    }
  }, [enterpriseByTaxCode]);

  // Action Dispatch
  useEffect(() => {
    console.log("error", errors);
  }, [errors]);

  const [listUploadFile, setListUploadFile] = useState([]);
  const [listHaveUploadFile, setListHaveUploadFile] = useState([]);
  // Action Dispatch
  useEffect(() => {
    if (uploadFile && uploadFile.success) {
      setListUploadFile([
        ...listUploadFile,
        { id: uploadFile.id, file_name: "" },
      ]);
      dispatch(resetUploadAttackFileInvoice());
    }
    // console.log("error", errors);
  }, [uploadFile]);

  // setDefaultConfigField
  useEffect(() => {
    if (configField.isFinish) {
      setDefaultConfigField();
      addNewLineHHDV();
      if (dataDetail.id) {
        dispatch(getDetailIssueInvoice(dataDetail.id, typeInvoiceAnother));
      }
    }
  }, [configField]);

  const setFileHaveUpload = () => {
    const listUploadFile = [];
    if (detailIssueInvoice?.resource_list) {
      for (const item of detailIssueInvoice.resource_list) {
        if (item.type === "attach") {
          const splitType = item.file_name.split(".");
          const fileType = splitType[splitType.length - 1];
          listUploadFile.push({
            id: item.id,
            file_name: item.file_name.split("-")[0],
            file_type: fileType,
          });
        }
      }
      setListHaveUploadFile(listUploadFile);
    }
  };

  useEffect(() => {
    if (detailIssueInvoice) {
      switch (detailIssueInvoice?.invoice_type) {
        case 1:
          setPageView(issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE);
          break;
        case 0:
          setPageView(issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE);
          break;
        default:
          break;
      }
      //Disalbe custom field nếu có
      if (
        detailIssueInvoice.is_editable === 0 ||
        detailIssueInvoice.is_editable === false
        //   &&
        // // Điều chỉnh giảm và thay thế mode tạo mới lần đầu
        // (dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
        //   (dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST &&
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE) ||
        //   // Điều chỉnh giảm và thay thế mode lần sau
        //   dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.REPLACE ||
        //   (dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.ADJUST &&
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE))
      ) {
        setIsEditableAdjustReplace(false);
      }
      // Nếu là hóa đơn điều chỉnh giảm lần đầu thì gợi ý âm số lượng
      let isCreateAdjustDecreaseInvoice =
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE &&
        !dataConfirmAction.modeEdit &&
        mode !== issueInvoiceModeList.VIEW_DELIVERY_BILL_DETAIL;
      setFileHaveUpload();
      setDefaultValue(COMMON_FIELD);
      setDefaultValue(ISSUE_INVOICE_SELLER_FIELD);
      setDefaultValue(ISSUE_INVOICE_BUYER_FIELD);
      setValue("send_mail", detailIssueInvoice.send_mail);

      const invoiceDetails = detailIssueInvoice.invoiceDetails;
      // set detail value cho THÔNG TIN DANH SÁCH HDDV
      if (invoiceDetails && invoiceDetails.length > 0) {
        // tchat mhhdvu thhdvu dvtinh sluong dgia tlckhau stckhau tsuat thtien ttkhac
        setValue(
          ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.field,
          invoiceDetails.map(item => {
            let tsuatDetail = null;
            if (item.tsuat) {
              tsuatDetail = listVat.find(option => option.label === item.tsuat);
              // Trường hợp tsuat là input value
              if (!tsuatDetail) {
                tsuatDetail = {
                  value: Number(item.tsuat.replace(/KHAC:|.00%/g, "")),
                  label: item.tsuat,
                };
              }
            } else {
              tsuatDetail = {
                value: "",
                label: "",
              };
            }
            //Mã hàng hóa, dịch vụ, diễn giải
            let mhhdvuDetail = null;
            if (item.mhhdvu) {
              mhhdvuDetail = {
                value: item.mhhdvu,
                label: item.mhhdvu,
              };
            }
            //Tên hàng hóa, dịch vụ, diễn giải
            let thhdvuDetail = {
              value: item.thhdvu,
              label: item.thhdvu,
            };
            //

            let sluong = item.sluong;
            let thtien = item.thtien;
            let dgia = item.dgia;
            if (isCreateAdjustDecreaseInvoice) {
              //   sluong = 0;
              sluong = sluong > 0 ? -sluong : sluong;
              thtien = thtien > 0 ? -thtien : thtien;
            }
            return {
              tchat: OPTION_HHDV_TCHAT.find(
                option => Number(option.value) === Number(item.tchat)
              ),
              mhhdvu: mhhdvuDetail,
              thhdvu: thhdvuDetail,
              dvtinh: item.dvtinh,
              sluong: sluong,
              dgia: dgia,
              tlckhau: item.tlckhau,
              stckhau: item.stckhau,
              tsuat: tsuatDetail,
              thtien: thtien,
              ttkhac: item.ttkhac,
            };
          })
        );
      }

      if (isCreateAdjustDecreaseInvoice) {
        setTimeout(() => {
          autoSumGroupAll();
        });
      }
    }
  }, [detailIssueInvoice]);

  // Custom set default value
  const setDefaultValue = FIELDS => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      let finalValue = detailIssueInvoice[finalKey];
      if (finalValue) {
        switch (type) {
          case "object":
            setValue(finalKey, finalValue, { shouldValidate: true });
            break;
          case "select":
            const option = OPTION_GROUP[finalKey];
            const valueSelect = option.find(item => item.value === finalValue);
            setValue(finalKey, valueSelect, { shouldValidate: true });
            break;
          case "number":
          case "text":
            // Mode thay thế hóa đơn và điều chỉnh
            if (
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST
            ) {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_SHDON.field:
                  setValue(finalKey, "Chờ cấp số", { shouldValidate: true });
                  break;
                case COMMON_FIELD.TTCHUNG_KHHDON.field:
                  // Set ký hiệu theo năm trên hệ thống
                  if (dataConfirmAction?.finalSerial) {
                    finalValue = dataConfirmAction?.finalSerial;
                  }
                  const subValue = String(finalValue).substring(
                    String(finalValue).length - 2
                  );
                  const khhdonDefault = String(finalValue).substring(
                    0,
                    String(finalValue).length - 2
                  );
                  setKhhdonDefault(khhdonDefault);
                  setValue(
                    finalKey,
                    {
                      value: subValue,
                      label: subValue,
                    },
                    { shouldValidate: true }
                  );
                  break;
                default:
                  setValue(finalKey, finalValue, { shouldValidate: true });
                  break;
              }
            } else {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_KHHDON.field:
                  // Nếu sang năm thì phải tăng năm
                  finalValue = changeYearOfSerial(
                    finalValue,
                    currentTime?.data?.year.toString()
                  );
                  const subValue = String(finalValue).substring(
                    String(finalValue).length - 2
                  );
                  const khhdonDefault = String(finalValue).substring(
                    0,
                    String(finalValue).length - 2
                  );
                  setKhhdonDefault(khhdonDefault);
                  setValue(
                    finalKey,
                    {
                      value: subValue,
                      label: subValue,
                    },
                    { shouldValidate: true }
                  );
                  break;
                default:
                  setValue(finalKey, finalValue, { shouldValidate: true });
                  break;
              }
            }
            break;
          case "date":
            if (
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST
            ) {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_NLAP.field:
                  setValue(
                    finalKey,
                    [getDateMidnight(currentTime?.data?.date)],
                    { shouldValidate: true }
                  );
                  break;
                default:
                  const date = formatTimestampToDate(finalValue);
                  setValue(finalKey, [date], { shouldValidate: true });
                  break;
              }
            } else {
              const date = formatTimestampToDate(finalValue);
              setValue(finalKey, [date], { shouldValidate: true });
            }
            break;
        }
      }
    }
  };

  const {
    fields: fieldsHHDV,
    append: appendHHDV,
    remove: removeHHDV,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: HHDV_FIELD.HHDV_OBJ.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const setTypeInvoice = () => {
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE:
        setTypeAnother(TYPE_INVOICE_ANOTHER.DELIVERY_BILL);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!isOpenModal) {
      setIsEditableAdjustReplace(true);
      dispatch(resetGetDetailIssueInvoice());
      setIsDetail(false);
      reset({ ...initDefaultValues });
      // setControlFields(initControlFields);
    } else {
      dispatch(getAllCustomerInvoice());
      setListUploadFile([]);
      checkDisableForm();
      setTypeInvoice();
      dispatch(loadConfigInvoiceField());
      //   addNewLineTTOAN_LPHI();
      switch (mode) {
        case issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL:
          setValue(
            COMMON_FIELD.TTCHUNG_THDON.field,
            "PHIẾU XUẤT KHO KIÊM VẬN CHUYỂN NỘI BỘ"
          );
          setValue(
            COMMON_FIELD.TTCHUNG_KHMSHDON.field,
            OPTION_TTCHUNG_KHMSHDON[0],
            { shouldValidate: true }
          );
          setValue(
            COMMON_FIELD.TTCHUNG_NLAP.field,
            initDefaultValues[COMMON_FIELD.TTCHUNG_NLAP.field],
            { shouldValidate: true }
          );
          break;
        default:
          break;
      }
      // setValue(COMMON_FIELD.TTCHUNG_KHHDON.field, khhdonDefault);
    }
  }, [dispatch, isOpenModal]);

  const checkDisableForm = () => {
    let isTypeAdjustIncDesc = false;
    if (dataConfirmAction) {
      switch (dataConfirmAction.mode) {
        // Thay thế hóa đơn
        case MODE_INVOICE_ACTION.REPLACE:
          setDisableForm(false);
          break;
        // Điều chỉnh hóa đơn
        case MODE_INVOICE_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            // Tăng, giảm
            case TYPE_ADJUST_INVOICE.INCREASE:
            case TYPE_ADJUST_INVOICE.DECREASE:
              isTypeAdjustIncDesc = true;
              break;
            // Điều chỉnh thông tin
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              break;
            default:
              break;
          }
          setDisableForm(true);
          break;
        default:
          break;
      }
      // Cập nhật lại hóa đơn điều chỉnh/thay thế ở trạng thái lưu tạm
      switch (dataConfirmAction.modeEdit) {
        // Thay thế hóa đơn
        case MODE_INVOICE_ACTION.REPLACE:
          setDisableForm(false);
          break;
        // Điều chỉnh hóa đơn
        case MODE_INVOICE_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            // Tăng, giảm
            case TYPE_ADJUST_INVOICE.INCREASE:
            case TYPE_ADJUST_INVOICE.DECREASE:
              isTypeAdjustIncDesc = true;
              break;
            // Điều chỉnh thông tin
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              break;
            default:
              break;
          }
          setDisableForm(true);
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        case issueInvoiceModeList.VIEW_DELIVERY_BILL_DETAIL:
          setDisableForm(true);
          break;
        default:
          setDisableForm(false);
          break;
      }
    }
    setIsTypeAdjustIncDesc(isTypeAdjustIncDesc);
  };

  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            ...optionDateLocale.locale,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            ...optionDateLocale.locale,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  // Action Dispatch
  useEffect(() => {
    if (issueInvoiceCreate && issueInvoiceCreate.success) {
      addToast(t("form.submit.create.invoice.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCreateIssueInvoice());
      toggleModal(mode);
    }
  }, [addToast, dispatch, issueInvoiceCreate, mode, t, toggleModal]);

  // Action Dispatch
  useEffect(() => {
    if (issueInvoiceEdit && issueInvoiceEdit.success) {
      addToast(t("form.submit.edit.invoice.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetEditIssueInvoice());
      toggleModal(mode);
    }
  }, [addToast, dispatch, issueInvoiceEdit, mode, t, toggleModal]);

  // Error Dispatch
  useEffect(() => {
    if (errorCreate) {
      addToast(t("form.submit.create.invoice.error"), {
        appearance: "error",
        autoDismiss: true,
      });

      if (errorCreate.code === 422 && errorCreate.fields.length > 0) {
        errorCreate.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "listInvoiceDetail":
              fieldName = HHDV_FIELD.HHDV_OBJ.field;
              break;
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, { type: "manual", message: item.message });
        });
      }
      dispatch(resetCreateIssueInvoice());
    }

    if (errorEdit) {
      addToast(t("form.submit.edit.invoice.error"), {
        appearance: "error",
        autoDismiss: true,
      });

      if (errorEdit.code === 422 && errorEdit.fields.length > 0) {
        errorEdit.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "listInvoiceDetail":
              fieldName = HHDV_FIELD.HHDV_OBJ.field;
              break;
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, { type: "manual", message: item.message });
        });
      }
      dispatch(resetEditIssueInvoice());
    }
  }, [
    HHDV_FIELD.HHDV_OBJ.field,
    addToast,
    dispatch,
    errorCreate,
    errorEdit,
    setError,
    t,
  ]);

  const onSubmit = values => {
    const isSaveInfoCustomer = values.isSaveInfoCustomer;
    const finalData = formatData(values);
    // lưu thông tin kh
    finalData["isSaveInfoCustomer"] = isSaveInfoCustomer;
    // Gửi mail
    finalData["send_mail"] = inputCBSendMailChange ? 1 : 0;
    // list sản phẩm check để tái sử dụng
    const listProduct = values.hhdv_obj
      .filter(item => item.mhhdvu && item.mhhdvu.value)
      .map(item => {
        return {
          code: item?.mhhdvu?.value,
          name: item?.thhdvu?.value,
          unit: item?.dvtinh,
          price: item?.dgia,
          id_vat: null,
          vat_text: null,
        };
      });
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE:
        finalData["invoice_type"] = "1";
        break;
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE:
        finalData["invoice_type"] = "0";
        break;
      default:
        break;
    }
    // console.log("🚀 ~ file: DetailBill.js ~ line 893 ~ finalData", finalData);
    // return;
    finalData.ttchung_shdon = null;
    if (dataConfirmAction) {
      // Thay thế hóa đơn
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          dispatch(
            replaceIssueInvoice(
              dataConfirmAction.id,
              listUploadFile.map(item => item.id),
              finalData,
              typeInvoiceAnother
            )
          );
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          dispatch(
            adjustIssueInvoice(
              dataConfirmAction.id,
              listUploadFile.map(item => item.id),
              dataConfirmAction.typeAdjust,
              finalData,
              typeInvoiceAnother
            )
          );
          break;
        default:
          break;
      }
      // Thay thế hóa đơn
      switch (dataConfirmAction.modeEdit) {
        case MODE_INVOICE_ACTION.REPLACE:
        case MODE_INVOICE_ACTION.ADJUST:
          finalData.adjust_mod = detailIssueInvoice.adjust_mod;
          dispatch(
            editIssueInvoice(finalData, dataDetail.id, typeInvoiceAnother)
          );
          break;
        default:
          break;
      }
    } else {
      // THêm sản phẩm mới
      dispatch(createListProductInvoice(listProduct));
      switch (mode) {
        case issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL:
          console.log(finalData, "finalData");
          dispatch(createIssueInvoice(finalData, typeInvoiceAnother));
          break;
        case issueInvoiceModeList.EDIT_DELIVERY_BILL_DETAIL:
          dispatch(
            editIssueInvoice(finalData, dataDetail.id, typeInvoiceAnother)
          );
          break;
        default:
          break;
      }
    }
  };

  const formatData = values => {
    const finalData = {};

    TOTAL_FIELD_ARRAY.map(item => {
      const itemField = TOTAL_FIELD[item];
      const valueField = values[itemField.field];
      switch (itemField.type) {
        case "object":
          finalData[itemField.field] = valueField;
          break;
        case "text":
          if (itemField.field === "ttchung_khhdon") {
            finalData[itemField.field] = `${khhdonDefault}${
              valueField?.value ? valueField.label : ""
            }`;
          } else {
            finalData[itemField.field] = valueField || "";
          }
          break;
        case "number":
          finalData[itemField.field] = Number(valueField);
          break;
        case "select":
          finalData[itemField.field] = valueField?.value
            ? valueField.value
            : "";
          break;
        case "date":
          finalData[itemField.field] = convertDate(valueField[0]);
          break;
        case "field_array":
          finalData[itemField.fieldReal] = [];

          const listField = itemField.list;
          const arrayField = [];
          for (const key in listField) {
            arrayField.push(key);
          }
          let stt = 0;
          finalData[itemField.fieldReal] = valueField.map(fieldChild => {
            stt = stt + 1;
            const finalDataFieldArray = {};
            arrayField.map(y => {
              const itemFieldArray = listField[y];
              const valueFieldArray = fieldChild[itemFieldArray.field];
              if (y === "STT") {
                finalDataFieldArray[itemFieldArray.fieldReal] = stt;
              } else {
                // console.log(itemFieldArray.type, "itemFieldArray.type");
                switch (itemFieldArray.type) {
                  case "text":
                    finalDataFieldArray[itemFieldArray.fieldReal] =
                      valueFieldArray || "";
                    break;
                  case "number":
                    finalDataFieldArray[itemFieldArray.fieldReal] =
                      Number(valueFieldArray);
                    break;
                  case "select":
                    if (
                      itemFieldArray.fieldReal === "tsuat" ||
                      itemFieldArray.fieldReal === "TSuat"
                    ) {
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        valueFieldArray && valueFieldArray.label;
                    } else {
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        valueFieldArray?.value || "";
                    }
                    // Luu thêm giá trị thuế suất vào db
                    if (itemFieldArray.fieldReal === "tsuat") {
                      finalDataFieldArray["tsuat_value"] =
                        valueFieldArray.value;
                    }
                    break;
                  case "date":
                    finalDataFieldArray[itemFieldArray.fieldReal] = convertDate(
                      valueFieldArray[0]
                    );
                    break;
                  default:
                    break;
                }
              }
            });
            return finalDataFieldArray;
          });
          break;
        default:
          break;
      }
    });

    return finalData;
  };

  const defaultValueLineHHDV = {
    [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT[0],
    [HHDV_FIELD.HHDV_OBJ.list.STT.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: undefined,
    [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: undefined,
    [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.DVTINH.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.SLUONG.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.DGIA.field]: "",
    // [HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field]: "",
    // [HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.THTIEN.field]: "",
    // [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: listVat[0],
    [HHDV_FIELD.HHDV_OBJ.list.TTKHAC.field]: "",
  };

  const addNewLineHHDV = () => {
    appendHHDV(defaultValueLineHHDV);
    // setTimeout(() => {
    // });
  };

  const caculateHHDV = (fieldArray, index, fieldChild) => {
    const value = getValues(HHDV_FIELD.HHDV_OBJ.field);
    const HDDV_OBJ = HHDV_FIELD.HHDV_OBJ;
    const THHDVU = HDDV_OBJ.list.THHDVU.field;
    const MHHDVU = HDDV_OBJ.list.MHHDVU.field;
    const SLUONG = HDDV_OBJ.list.SLUONG.field;
    const DVTINH = HDDV_OBJ.list.DVTINH.field;
    const DGIA = HDDV_OBJ.list.DGIA.field;
    const THTIEN = HDDV_OBJ.list.THTIEN.field;
    // const TSUAT = HDDV_OBJ.list.TSUAT.field;
    const TCHAT = HDDV_OBJ.list.TCHAT.field;
    // const TLCKHAU = HDDV_OBJ.list.TLCKHAU.field;
    // const STCKHAU = HDDV_OBJ.list.STCKHAU.field;
    let currentValue = {};
    if (value) {
      currentValue = value[index];
      switch (fieldChild) {
        case DGIA:
        case SLUONG:
          // IF co nhap so luong va don gia
          if (currentValue[SLUONG] && currentValue[DGIA]) {
            currentValue[THTIEN] =
              Number(currentValue[SLUONG]) * Number(currentValue[DGIA]);
          } else if (!currentValue[SLUONG] || !currentValue[DGIA]) {
            // IF chưa nhap so luong hoac don gia
            currentValue[THTIEN] = "";
          }
          // Nếu là Hóa đơn điều chỉnh thì k tính số lượng
          if (
            dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.INCREASE ||
            dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE
          ) {
            currentValue[THTIEN] = Number(currentValue[DGIA]) * 1;
          }
          setValue(
            `${HDDV_OBJ.field}.${index}.${THTIEN}`,
            Number(currentValue[THTIEN]),
            {
              shouldValidate: true,
            }
          );
          autoSumGroupAll();
          break;
        // case TSUAT:
        // case STCKHAU:
        //   autoSumGroupAll();
        //   break;
        case TCHAT:
          if (
            currentValue[TCHAT].value === TCHAT_VALUES.GOODS ||
            currentValue[TCHAT].value === TCHAT_VALUES.PROMOTION
          ) {
            // if (!currentValue[TSUAT].value) {
            //   currentValue[TSUAT] = OPTION_HHDV_TSUAT[0];
            // }
            currentValue[SLUONG] = currentValue[SLUONG]
              ? currentValue[SLUONG]
              : 0;
            currentValue[DGIA] = currentValue[DGIA] ? currentValue[DGIA] : 0;
          }
          if (
            currentValue[TCHAT].value !== TCHAT_VALUES.GOODS &&
            currentValue[TCHAT].value !== TCHAT_VALUES.PROMOTION
          ) {
            currentValue[SLUONG] = "";
            currentValue[DGIA] = "";
            currentValue[DVTINH] = "";
            currentValue[THTIEN] = "";
            // currentValue[TSUAT] = {
            //   value: "",
            //   label: "",
            // };
            currentValue[MHHDVU] = "";
          }
          //   if (currentValue[TCHAT].value !== TCHAT_VALUES.DISCOUNT) {
          //     currentValue[STCKHAU] = "";
          //     currentValue[TLCKHAU] = "";
          //   }
          if (currentValue[TCHAT].value === TCHAT_VALUES.DISCOUNT) {
            // currentValue[STCKHAU] = 0;
            // currentValue[TSUAT] = OPTION_HHDV_TSUAT[0];
          }
          setValue(HDDV_OBJ.field, value, {
            shouldValidate: true,
          });
          autoSumGroupAll();
          break;
        case MHHDVU:
        case THHDVU: //
          const tchat = currentValue.tchat.value;
          const product = currentValue[fieldChild];
          // load thông tin khi chọn hàng hóa dịch vụ có sẵn
          if (product?.id) {
            switch (tchat) {
              case TCHAT_VALUES.GOODS:
              case TCHAT_VALUES.PROMOTION:
                //
                if (fieldChild === THHDVU) {
                  currentValue[MHHDVU] = {
                    value: product.code,
                    label: product.code,
                  };
                }
                if (fieldChild === MHHDVU) {
                  currentValue[THHDVU] = {
                    value: product.name,
                    label: product.name,
                  };
                }
                //
                currentValue[DVTINH] = product.unit;
                currentValue[DGIA] = Number(product.price);

                if (currentValue[SLUONG] && currentValue[DGIA]) {
                  currentValue[THTIEN] =
                    Number(currentValue[SLUONG]) * Number(currentValue[DGIA]);
                } else if (!currentValue[SLUONG] || !currentValue[DGIA]) {
                  // IF chưa nhap so luong hoac don gia
                  currentValue[THTIEN] = "";
                }
                break;
              case TCHAT_VALUES.DISCOUNT:
                //
                if (fieldChild === THHDVU) {
                  currentValue[MHHDVU] = {
                    value: product.code,
                    label: product.code,
                  };
                }
                if (fieldChild === MHHDVU) {
                  currentValue[THHDVU] = {
                    value: product.name,
                    label: product.name,
                  };
                }
                //
                break;
              case TCHAT_VALUES.EXPLAIN:
                break;
              default:
                break;
            }
            setValue(HDDV_OBJ.field, value, {
              shouldValidate: true,
            });
            autoSumGroupAll();
          }
          break;
        default:
          break;
      }
    }
  };

  const autoSumGroupAll = () => {
    const valueHHDV = getValues(HHDV_FIELD.HHDV_OBJ.field);
    //Thông tin tổng hợp của mỗi loại thuế suất
    const groupTsuat = {};
    let ttoan_ttcktmai = 0; //Tổng tiền chiết khấu thương mại
    let ttoan_tgtcthue = 0; //Tổng tiền chưa thuế
    let ttoan_tgtthue = 0; //Tổng tiền thuế
    let ttoan_tgtttbso = 0; //Tổng tiền thanh toán bằng số
    for (const item of valueHHDV) {
      const tsuatLabel = item.tsuat ? item.tsuat.label : "";
      const tsuatValue = item.tsuat ? item.tsuat.value : 0;
      const tchat = item.tchat.value;
      // Tính chất là hàng hóa dịch vụ/khuyến mãi
      if (tchat === "1" || tchat === "2") {
        let ttoan_tthue = 0;
        let thtien = 0;
        //Auto fill Thông tin tổng hợp của mỗi loại thuế suất
        thtien = item.thtien ? item.thtien : 0;
        if (tsuatLabel === "KCT" || tsuatLabel === "KKKNT") {
          ttoan_tthue = (item.thtien * tsuatValue) / 100;
          if (groupTsuat[tsuatLabel]) {
            groupTsuat[tsuatLabel].ttoan_thtien =
              groupTsuat[tsuatLabel].ttoan_thtien + Number(thtien);
            groupTsuat[tsuatLabel].ttoan_tthue =
              groupTsuat[tsuatLabel].ttoan_tthue + Number(ttoan_tthue);
          } else {
            groupTsuat[tsuatLabel] = {
              valueOption: item.tsuat?.value
                ? item.tsuat
                : {
                    value: "",
                    label: "",
                  },
              ttoan_thtien: Number(thtien),
              ttoan_tthue: Number(ttoan_tthue),
            };
          }
        } else {
          ttoan_tthue = (item.thtien * tsuatValue) / 100;
          if (groupTsuat[tsuatValue]) {
            groupTsuat[tsuatValue].ttoan_thtien =
              groupTsuat[tsuatValue].ttoan_thtien + Number(thtien);
            groupTsuat[tsuatValue].ttoan_tthue =
              groupTsuat[tsuatValue].ttoan_tthue + Number(ttoan_tthue);
          } else {
            groupTsuat[tsuatValue] = {
              valueOption: item.tsuat?.value
                ? item.tsuat
                : {
                    value: "",
                    label: "",
                  },
              ttoan_thtien: Number(thtien),
              ttoan_tthue: Number(ttoan_tthue),
            };
          }
        }

        //Tổng tiền chưa thuế
        ttoan_tgtcthue = Number(ttoan_tgtcthue) + Number(thtien);
        //Tổng tiền thuế
        ttoan_tgtthue = Number(ttoan_tgtthue) + Number(ttoan_tthue);
        // //Tổng tiền thanh toán bằng số
        // ttoan_tgtttbso = ttoan_tgtttbso + (Number(thtien) + ttoan_tthue);
      }
      if (tchat === "3") {
        //Tổng tiền chiết khấu thương mại
        ttoan_ttcktmai = ttoan_ttcktmai + Number(item.stckhau);
      }
    }
    const sumTsuatList = [];
    // Auto fill Thông tin tổng hợp của mỗi loại thuế suất
    for (const item in groupTsuat) {
      sumTsuatList.push({
        ttoan_tsuat: groupTsuat[item].valueOption,
        ttoan_thtien: groupTsuat[item].ttoan_thtien,
        ttoan_tthue: Math.round(groupTsuat[item].ttoan_tthue),
      });
    }
    if (sumTsuatList.length > 0) {
      setValue("ttoan_ltsuat_obj", sumTsuatList);
    } else {
      setValue("ttoan_ltsuat_obj", [
        {
          ttoan_tsuat: {
            value: "",
            label: "",
          },
          ttoan_thtien: "",
          ttoan_tthue: "",
        },
      ]);
    }
    ttoan_tgtthue = Math.round(ttoan_tgtthue);
    //Tổng tiền chưa thuế
    setValue("ttoan_tgtcthue", ttoan_tgtcthue);
    //Tổng tiền thuế
    setValue("ttoan_tgtthue", ttoan_tgtthue);
    //Tổng tiền chiết khấu thương mại
    setValue("ttoan_ttcktmai", ttoan_ttcktmai);
    //Tổng tiền thanh toán bằng số
    ttoan_tgtttbso = ttoan_tgtcthue + ttoan_tgtthue - ttoan_ttcktmai;
    setValue("ttoan_tgtttbso", ttoan_tgtttbso);
    //Tổng tiền thanh toán bằng chữ
    let dv = "";
    switch (getValues("ttchung_dvtte")?.value) {
      case "VND":
        dv = " đồng";
        break;
      case "USD":
        dv = " đô la Mỹ";
        break;
      default:
        break;
    }
    let ttoan_tgtttbchu = docso(Math.abs(ttoan_tgtttbso));
    ttoan_tgtttbchu = fixConvertNumberToText(ttoan_tgtttbchu);
    ttoan_tgtttbchu =
      ttoan_tgtttbchu.charAt(0).toUpperCase() + ttoan_tgtttbchu.slice(1);
    let textChange = "";
    switch (dataConfirmAction?.typeAdjust) {
      case TYPE_ADJUST_INVOICE.INCREASE:
        textChange = "Điều chỉnh tăng ";
        break;
      case TYPE_ADJUST_INVOICE.DECREASE:
        textChange = "Điều chỉnh giảm ";
        break;
      default:
        break;
    }
    setValue("ttoan_tgtttbchu", textChange + ttoan_tgtttbchu + dv);
  };

  // Delay when MST người bán  Change
  const [disableBtnInfoByTax, setDisableBtnInfoByTax] = useState(true);
  const [inputMSTChange, setInputMSTChange] = useState(null);
  const [inputCBSendMailChange, setInputCBSendMailChange] = useState(false);

  useEffect(() => {
    const delayDebounceTAXFn = setTimeout(() => {
      if (inputMSTChange) {
        if (inputMSTChange.length === 10 || inputMSTChange.length === 14) {
          dispatch(getEnterpriseByTaxCode(inputMSTChange));
        }
      }
    }, 500);
    return () => clearTimeout(delayDebounceTAXFn);
  }, [inputMSTChange]);

  useEffect(() => {
    if (!loadDingEnterpriseByTaxCode) {
      setDisableBtnInfoByTax(false);
    }
  }, [loadDingEnterpriseByTaxCode]);

  // Delay when input HDDV Change
  const [inputValueChange, setInputValueChange] = useState(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (inputValueChange) {
        caculateHHDV(
          inputValueChange.fieldArray,
          inputValueChange.index,
          inputValueChange.fieldChild
        );
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [inputValueChange]);
  //
  const generateTable = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    //
    let fieldDisableConfig = {};
    if (!isEditableAdjustReplace) {
      fieldDisableConfig = FIELD_DISABLE_CONFIG[fieldContanst];
    }
    return (
      <div className="custom-table-border" style={{ ...styleTable }}>
        <Table className="table  table-bordered">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "20px" }}>
                STT
              </th>
              {Object.entries(listContanst)
                .filter(([k, v]) => !v.isHide && checkShowWithPageView(v))
                .map(([key, value]) => {
                  return (
                    <th
                      style={{ width: value.width }}
                      className="text-center"
                      key={key}
                    >
                      {t(`form.${value.field}`)}{" "}
                      {value.required && (
                        <span className="text-danger"> (*)</span>
                      )}
                    </th>
                  );
                })}
              {!isAuto && <th style={{ width: "20px" }}></th>}
            </tr>
          </thead>
          <tbody>
            {fieldsArray.map((field, index) => {
              const fieldMain = fieldContanst;
              const listField = listContanst;
              const arrayField = [];
              for (const key in listField) {
                if (
                  !listField[key].isHide &&
                  checkShowWithPageView(listField[key])
                ) {
                  arrayField.push(key);
                }
              }
              const tdStyle = {
                display: "table-cell",
                verticalAlign: "bottom",
              };
              return (
                <tr key={field.key}>
                  <td>{index + 1}</td>
                  {arrayField.map(item => {
                    const itemField = listField[item];
                    let watchDisable = disableForm;
                    if (!watchDisable) {
                      if (fieldMain === HHDV_FIELD.HHDV_OBJ.field) {
                        switch (itemField.field) {
                          case HHDV_FIELD.HHDV_OBJ.list.TCHAT.field:
                          case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                            watchDisable = false;
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.THTIEN.field:
                            watchDisable = true;
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                          case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                          //   case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                          case HHDV_FIELD.HHDV_OBJ.list.DVTINH.field:
                            //   case HHDV_FIELD.HHDV_OBJ.list.TSUAT.field:
                            watchDisable =
                              watch(`hhdv_obj`)[index]["tchat"].value !== "1" &&
                              watch(`hhdv_obj`)[index]["tchat"].value !== "2";
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                            watchDisable =
                              watch(`hhdv_obj`)[index]["tchat"].value !== "1" &&
                              watch(`hhdv_obj`)[index]["tchat"].value !== "2" &&
                              watch(`hhdv_obj`)[index]["tchat"].value !== "3";
                            break;
                            //   case HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field:
                            //   case HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field:
                            //     watchDisable =
                            //       watch(`hhdv_obj`)[index]["tchat"].value !== "3";
                            break;
                          default:
                            break;
                        }
                      } else {
                        watchDisable = true;
                      }
                    } else {
                      // Nếu điều chỉnh hóa đơn tăng giảm thì chỉ cho chỉnh số lượng và đơn giá
                      if (
                        isTypeAdjustIncDesc &&
                        fieldMain === HHDV_FIELD.HHDV_OBJ.field
                      ) {
                        //   switch (itemField.field) {
                        //     //   case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                        //     case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                        //       if (
                        //         (watch(`hhdv_obj`)[index]["tchat"].value ===
                        //           "1" ||
                        //           watch(`hhdv_obj`)[index]["tchat"].value ===
                        //             "2") &&
                        //         isTypeAdjustIncDesc
                        //       )
                        //         watchDisable = false;
                        //       break;
                        //     default:
                        //       break;
                        //   }
                        switch (itemField.field) {
                          case HHDV_FIELD.HHDV_OBJ.list.TCHAT.field:
                          case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                            watchDisable = false;
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.THTIEN.field:
                            watchDisable = true;
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                          case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                          //   case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                          case HHDV_FIELD.HHDV_OBJ.list.DVTINH.field:
                            //   case HHDV_FIELD.HHDV_OBJ.list.TSUAT.field:
                            watchDisable =
                              watch(`hhdv_obj`)[index]["tchat"].value !== "1" &&
                              watch(`hhdv_obj`)[index]["tchat"].value !== "2";
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                            watchDisable =
                              watch(`hhdv_obj`)[index]["tchat"].value !== "1" &&
                              watch(`hhdv_obj`)[index]["tchat"].value !== "2" &&
                              watch(`hhdv_obj`)[index]["tchat"].value !== "3";
                            break;
                          case HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field:
                          case HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field:
                            watchDisable =
                              watch(`hhdv_obj`)[index]["tchat"].value !== "3";
                            break;
                          default:
                            break;
                        }
                      }
                    }
                    let allowNegative = false;
                    // Disable field theo config
                    if (
                      fieldDisableConfig &&
                      fieldDisableConfig[itemField.field]
                    ) {
                      watchDisable = fieldDisableConfig[itemField.field];
                    }
                    switch (itemField.type) {
                      case "text":
                      case "number":
                        // điều chỉnh giảm thi  cho nhập đơn giá/số lượng âm
                        if (
                          (itemField.field === "sluong" ||
                            itemField.field === "dgia" ||
                            itemField.field === "ttoan_tsuat" ||
                            itemField.field === "ttoan_thtien" ||
                            itemField.field === "ttoan_tthue" ||
                            itemField.field === "thtien") &&
                          dataConfirmAction?.typeAdjust ===
                            TYPE_ADJUST_INVOICE.DECREASE
                        ) {
                          allowNegative = true;
                        }
                        return (
                          <td style={tdStyle} key={item}>
                            {generateInputFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              itemField.type,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.enter", {
                                    title: t(`form.${itemField.field}`),
                                  })
                                : "",
                              register,
                              watchDisable,
                              setInputValueChange,
                              control,
                              itemField.isThousandSeparator,
                              allowNegative,
                              itemField.maxValue
                            )}
                          </td>
                        );
                      case "select":
                        return (
                          <td key={item}>
                            {generateSelectFieldArray(
                              watch,
                              t(`form.${itemField.field}`),
                              itemField.required,
                              errors,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.select")
                                : "",
                              watchDisable,
                              control,
                              OPTION_GROUP[itemField.field],
                              caculateHHDV,
                              "top",
                              itemField.allowCreate
                            )}
                          </td>
                        );
                      case "date":
                        return (
                          <td key={item}>
                            <FormGroup className="mb-2">
                              {generateDateField(
                                t(`form.${itemField.field}`),
                                "",
                                itemField.required,
                                errors,
                                itemField.field,
                                "DD/MM/YYYY",
                                itemField.disabled,
                                control,
                                optionDateLocale
                              )}
                            </FormGroup>
                          </td>
                        );
                      default:
                        break;
                    }
                  })}
                  {!isAuto && (
                    <td>
                      {!disableForm && !isTypeAdjustIncDesc && (
                        <React.Fragment>
                          <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                            {fieldsArray.length > 1 && (
                              <i
                                onClick={() => {
                                  removeFunc(index);
                                  setTimeout(() => {
                                    autoSumGroupAll();
                                  });
                                }}
                                className="mdi mdi-trash-can  text-danger font-size-18"
                                style={{ cursor: "pointer" }}
                              />
                            )}

                            {index === fieldsArray.length - 1 && (
                              <i
                                onClick={addFunc}
                                className="fas fa-plus  text-primary label-icon"
                                style={{ cursor: "pointer" }}
                              ></i>
                            )}
                          </div>
                        </React.Fragment>
                      )}
                      {dataConfirmAction?.typeAdjust ===
                        TYPE_ADJUST_INVOICE.DECREASE && (
                        <React.Fragment>
                          <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                            {fieldsArray.length > 1 && (
                              <i
                                onClick={() => {
                                  removeFunc(index);
                                  setTimeout(() => {
                                    autoSumGroupAll();
                                  });
                                }}
                                className="mdi mdi-trash-can  text-danger font-size-18"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </div>
                        </React.Fragment>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const onChangeHandle = (data, field) => {
    switch (field) {
      case "send_mail":
        setInputCBSendMailChange(data);
        break;
      case "ttchung_dvtte":
        autoSumGroupAll();
        break;
      case "nmua_mst":
        setInputMSTChange(data);
        if (data.length === 10 || data.length === 14) {
          setDisableBtnInfoByTax(true);
        }
        break;
      default:
        break;
    }
  };

  const setEnterpriseInfo = (info, listMapValue) => {
    for (const key in listMapValue) {
      const defaultValue = info[listMapValue[key]];
      if (defaultValue) {
        setValue(key, defaultValue, { shouldValidate: true });
      } else {
        setValue(key, "", { shouldValidate: true });
      }
    }
  };

  // Set info người mua theo MST
  const setInfoBuyerByTaxCode = () => {
    if (enterpriseByTaxCode.enterpriseInfo) {
      const defaultEnterpriseInfo = {
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field]: "companyNameVn",
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field]: "registeredAddressVn",
        // [ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field]: "phone",
        // [ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field]: "email",
      };
      setEnterpriseInfo(
        enterpriseByTaxCode.enterpriseInfo,
        defaultEnterpriseInfo
      );
    }
    // if (enterpriseByTaxCode.entRepResentative) {
    //   const defaultEnterpriseInfo = {
    //     [ISSUE_INVOICE_BUYER_FIELD.NMUA_HVTNMHANG.field]: "representativeName",
    //   };
    //   setEnterpriseInfo(
    //     enterpriseByTaxCode.entRepResentative,
    //     defaultEnterpriseInfo
    //   );
    // }
  };

  // Button load thông tin theo MST
  const buttonLoadBuyerInfoByTax = () => {
    const disableBtn =
      disableBtnInfoByTax ||
      (getValues("nmua_mst").length !== 10 &&
        getValues("nmua_mst").length !== 14) ||
      loadDingEnterpriseByTaxCode ||
      !enterpriseByTaxCode ||
      !enterpriseByTaxCode.enterpriseInfo;
    return (
      !disableForm && (
        <React.Fragment>
          <button
            type="button"
            disabled={disableBtn}
            className={`btn btn-${disableBtn ? "warning" : "success"}`}
            onClick={() => {
              setInfoBuyerByTaxCode();
            }}
          >
            <i
              className={`${
                loadDingEnterpriseByTaxCode
                  ? "bx bx-loader bx-spin"
                  : "fa fa-exclamation-circle"
              } font-size-16 align-middle me-2`}
            ></i>
            {disableBtn ? "Chưa có thông tin" : "Load thông tin theo MST"}
          </button>
          {isShowBtnAddCustomer && (
            <React.Fragment>
              <input
                type="checkbox"
                id="checkbox_isSaveInfoCustomer"
                className="custom-control-input checkbox-isSaveInfoCustomer"
                style={{
                  width: "20px",
                  height: "20px",
                  marginTop: 0,
                }}
                {...register("isSaveInfoCustomer")}
              />
              <label
                style={{ marginLeft: "4px", marginBottom: 0 }}
                htmlFor="checkbox_isSaveInfoCustomer"
              >
                Lưu thông tin khách hàng để sử dụng lại
              </label>
            </React.Fragment>
          )}
        </React.Fragment>
      )
    );
  };

  // Button tìm khách hàng
  const buttonSeachCustomer = () => {
    return (
      !disableForm && (
        <button
          type="button"
          style={{ width: "124px" }}
          className={`btn btn-primary`}
          onClick={() => {
            toggleSearchModal();
          }}
        >
          <i
            className={`fas fa-search-plus font-size-16 align-middle me-2`}
          ></i>
          Tìm kiếm
        </button>
      )
    );
  };

  const getTitleModal = () => {
    let title = "";
    if (dataConfirmAction) {
      // Thay thế hóa đơn
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Lập hóa đơn thay thế";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          let typeAdjust = "";
          switch (dataConfirmAction.typeAdjust) {
            case TYPE_ADJUST_INVOICE.INCREASE:
              typeAdjust = "tăng";
              break;
            case TYPE_ADJUST_INVOICE.DECREASE:
              typeAdjust = "giảm";
              break;
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              typeAdjust = "thay đổi thông tin";
              break;
            default:
              break;
          }
          title = "Lập hóa đơn điều chỉnh " + typeAdjust;
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        // Tạo mới
        case issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL:
          title = "Thêm mới phiếu xuất kho";
          break;
        // Cập nhật
        case issueInvoiceModeList.EDIT_DELIVERY_BILL_DETAIL:
          title = "Cập nhật phiếu xuất kho";
          break;
        default:
          break;
      }
    }
    return title;
  };

  const getTextLinkOldInvoice = () => {
    let title = "";
    let id = null;
    if (dataConfirmAction) {
      // Thay thế hóa đơn
      const today = new Date(Number(dataConfirmAction.nlap) * 1000);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = `Thay thế cho hóa đơn Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = `Điều chỉnh cho hóa đơn Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        default:
          break;
      }
      id = dataConfirmAction.id;
    }
    //
    if (dataDetail.root) {
      const today = new Date(dataDetail.root.ttchung_nlap);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      switch (dataDetail.tthdlquan_tchdon) {
        case "1":
          title = `Thay thế cho hóa đơn Mẫu số: ${dataDetail.root.ttchung_khmshdon}, Ký hiệu: ${dataDetail.root.ttchung_khhdon}, Số: ${dataDetail.root.ttchung_shdon}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        case "2":
          title = `Điều chỉnh cho hóa đơn Mẫu số: ${dataDetail.root.ttchung_khmshdon}, Ký hiệu: ${dataDetail.root.ttchung_khhdon}, Số: ${dataDetail.root.ttchung_shdon}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        default:
          break;
      }
      id = dataDetail.root.id;
    }

    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          showPdfById(id);
        }}
        className="text-danger text-center font-size-20"
      >
        {title}
      </div>
    );
  };

  const getLabelButtonSubmit = () => {
    let title = "";
    if (dataConfirmAction) {
      // Thay thế /điều chỉnh hóa đơn
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Lập hóa đơn";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = "Lập hóa đơn";
          break;
        default:
          break;
      }
      // Cập nhật hóa đơn Thay thế /điều chỉnh ở trạng thái lưu tạm
      switch (dataConfirmAction.modeEdit) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Cập nhật hóa đơn";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = "Cập nhật hóa đơn";
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        // Tạo mới
        case issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL:
          title = "Lưu tạm";
          break;
        // Cập nhật
        case issueInvoiceModeList.EDIT_DELIVERY_BILL_DETAIL:
          title = "Cập nhật";
          break;
        default:
          break;
      }
    }
    return title;
  };

  const numberWithCommas = (x, isShow) => {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const isErrorAdjust = () => {
    // return (
    //   (getValues("ttoan_tgtttbso") -
    //     Number(detailIssueInvoice?.ttoan_tgtttbso) >=
    //     0 &&
    //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE) ||
    //   (getValues("ttoan_tgtttbso") -
    //     Number(detailIssueInvoice?.ttoan_tgtttbso) <=
    //     0 &&
    //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.INCREASE)
    // );
    return false;
  };

  //Check show/hide with page view
  const checkShowWithPageView = item => {
    if (item.isShowWithPageView && item.isShowWithPageView.length > 0) {
      if (item.isShowWithPageView.findIndex(item => item === pageView) === -1) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  const mapData = {
    [FIELD_CUSTOMER.TEN]: ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field,
    [FIELD_CUSTOMER.MST]: ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
    [FIELD_CUSTOMER.DCHI]: ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field,
  };
  const handleFiles = (files, uploadType = "") => {
    if (files.length > 0) {
      for (const item of files) {
        const bodyFormData = new FormData();
        bodyFormData.append("file", item);
        dispatch(uploadAttackFileInvoice(bodyFormData, uploadType));
      }
      if (modal && modal.current) {
        modal.current.scrollTop = modal.current.scrollHeight;
      }
    }
  };

  return (
    <React.Fragment>
      <SearchCustomerModal
        mapData={mapData}
        setValueFunc={setValue}
        isOpen={modalSearch}
        toggle={toggleSearchModal}
      ></SearchCustomerModal>
      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "95%" }}
      >
        <ModalHeader toggle={toggleModal}>{getTitleModal()}</ModalHeader>
        {loadingConfigField || loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "74vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div>{getTextLinkOldInvoice()}</div>
                <div
                  className="custom-form-heading"
                  style={{ paddingTop: "0px" }}
                >
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN CHUNG</strong>
                </div>

                <Row className="row-cols-1 row-cols-md-2">
                  {Object.entries(COMMON_FIELD).map(([key, value]) => {
                    return loopGenerateField(
                      value,
                      t(`form.${value.field}`),
                      t("placeholder.enter", {
                        title: t(`form.${value.field}`),
                      }),
                      errors,
                      touchedFields,
                      register,
                      control,
                      OPTION_GROUP,
                      optionDateLocale,
                      "",
                      onChangeHandle,
                      pageView,
                      null,
                      disableForm,
                      true,
                      invoiceSymbolList,
                      khhdonDefault,
                      currentTime?.data?.momentDate
                    );
                  })}
                </Row>
                <div className="custom-form-heading mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN NGƯỜI XUẤT HÀNG</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {Object.entries(ISSUE_INVOICE_SELLER_FIELD).map(
                    ([key, value]) => {
                      return loopGenerateField(
                        value,
                        t(`form.${value.field}`),
                        t("placeholder.enter", {
                          title: t(`form.${value.field}`),
                        }),
                        errors,
                        touchedFields,
                        register,
                        control,
                        OPTION_GROUP,
                        optionDateLocale,
                        "",
                        null,
                        "",
                        null,
                        disableForm
                      );
                    }
                  )}
                </Row>
                <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN NGƯỜI NHẬN HÀNG</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {Object.entries(ISSUE_INVOICE_BUYER_FIELD).map(
                    ([key, value]) => {
                      let placeholder = "";
                      if (value.field === "nmua_mst") {
                        placeholder = "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)";
                      } else {
                        placeholder = t("placeholder.enter", {
                          title: t(`form.${value.field}`),
                        });
                      }
                      return loopGenerateField(
                        value,
                        t(`form.${value.field}`),
                        placeholder,
                        errors,
                        touchedFields,
                        register,
                        control,
                        OPTION_GROUP,
                        optionDateLocale,
                        "",
                        onChangeHandle,
                        "",
                        {
                          [EXTRA_BUTTON.LOAD_TAX]: buttonLoadBuyerInfoByTax(),
                          [EXTRA_BUTTON.SEARCH_CUSTOMER]: buttonSeachCustomer(),
                        },
                        disableForm,
                        dataConfirmAction?.typeAdjust !==
                          TYPE_ADJUST_INVOICE.CHANGE_INFO
                      );
                    }
                  )}
                </Row>
                <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN DANH SÁCH HDDV</strong>
                </div>
                {generateTable(
                  HHDV_FIELD.HHDV_OBJ.field,
                  HHDV_FIELD.HHDV_OBJ.list,
                  fieldsHHDV,
                  removeHHDV,
                  addNewLineHHDV
                )}
                {(isShowAttacksFile &&
                  (dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
                    dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST)) ||
                listHaveUploadFile.length > 0 ? (
                  <React.Fragment>
                    <div className="custom-form-heading  mt-1">
                      <i className="fas fa-paperclip text-primary"></i>
                      <strong>BIÊN BẢN ĐÍNH KÈM</strong>
                    </div>
                    {(dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
                      dataConfirmAction?.mode ===
                        MODE_INVOICE_ACTION.ADJUST) && (
                      <Row>
                        <Col>
                          <UploadForm
                            multiple={true}
                            handleFiles={files => handleFiles(files)}
                            accept=".doc,.docx,.pdf"
                            removeFile={(a, index) => {
                              listUploadFile.splice(index, 1);
                              setListUploadFile(listUploadFile);
                            }}
                          ></UploadForm>
                        </Col>
                      </Row>
                    )}
                    {listHaveUploadFile.length > 0 &&
                      dataConfirmAction?.mode !== MODE_INVOICE_ACTION.REPLACE &&
                      dataConfirmAction?.mode !==
                        MODE_INVOICE_ACTION.ADJUST && (
                        <React.Fragment>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {listHaveUploadFile.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row
                                      className="align-items-center"
                                      onClick={() => {
                                        dispatch(
                                          downloadXmlIssueInvoice(
                                            f.id,
                                            f.file_name,
                                            "blob",
                                            null,
                                            "." + f.file_type
                                          )
                                        );
                                      }}
                                    >
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold align-items-center font-size-18 d-flex gap-2"
                                        >
                                          <i
                                            className={`${getIconFile(
                                              f.file_type
                                            )} label-icon`}
                                          ></i>
                                          {f.file_name + "." + f.file_type}
                                        </Link>
                                        {/* <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </React.Fragment>
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              {mode !== issueInvoiceModeList.VIEW_DELIVERY_BILL_DETAIL && (
                <Button
                  color="primary"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                  disabled={
                    loadingCreate ||
                    loadingEdit ||
                    loadingUploadFile ||
                    isErrorAdjust()
                  }
                >
                  <i className="bx bx-save label-icon"></i>
                  {getLabelButtonSubmit()}
                </Button>
              )}
              {mode === issueInvoiceModeList.VIEW_DELIVERY_BILL_DETAIL && (
                <React.Fragment>
                  {/* <Button
                    type="button"
                    color="primary"
                    className="btn-label"
                    onClick={() => {
                      let resource_id = null;
                      let type = "";
                      if (detailIssueInvoice?.auth_status === AUTH_STATUS_NEW) {
                        type = "raw";
                      } else {
                        type = "signed";
                      }
                      resource_id = getResourceIdXML(
                        detailIssueInvoice.resource_list,
                        type
                      );
                      dispatch(
                        downloadXmlIssueInvoice(
                          resource_id,
                          detailIssueInvoice?.ttchung_thdon,
                          "blob",
                          typeInvoiceAnother
                        )
                      );
                    }}
                  >
                    <i className="bx bx-download label-icon"></i>
                    Download XML
                  </Button> */}
                  {/* <Button
                    type="button"
                    color="danger"
                    className="btn-label"
                    onClick={() => {
                      //   dispatch(
                      //     downloadXmlIssueInvoice(
                      //       detailRegistryInvoices?.resource_id,
                      //       detailRegistryInvoices?.ttchung_thdon
                      //     )
                      //   );
                    }}
                  >
                    <i className="bx bxs-file-pdf label-icon"></i>
                    Download PDF
                  </Button> */}
                </React.Fragment>
              )}
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
};

DetailBill.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  showPdfById: PropTypes.func,
  dataDetail: PropTypes.object.isRequired,
  dataConfirmAction: PropTypes.any,
  mode: PropTypes.string.isRequired,
  typeInvoiceAnother: PropTypes.string,
  khhdonDefault: PropTypes.string,
  pageView: PropTypes.string,
  invoiceSymbolList: PropTypes.array.isRequired,
  isShowAttacksFile: PropTypes.bool,
  setKhhdonDefault: PropTypes.any,
  setPageView: PropTypes.any,
};

DetailBill.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  pageView: "",
  invoiceSymbolList: [],
  isShowAttacksFile: false,
};

export default DetailBill;
